import * as actionTypes from "./actionTypes";

const initialState = {
  isLoading: false,
  isLoadingModules: false,
  isLoadingActivities: false,
  trainingList: [],
  courseList: [],
  skillList: [],
  instructorList: [],
  userFieldsDefinition: [],
  training: null,
  trainingTree: null,
  modules: [],
  activities: [],
  media: [],
  activityTypes: [],
  questionTypes: [],
  sessionTypes: [],
  activity: null,
  canAssign: false,
  assignedCollaborators: [],
  collaboratorsList: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.RESET_ALL:
      return initialState;
    case actionTypes.GET_ALL_TRAINING:
      return { ...state, isLoading: true };
    case actionTypes.GET_ALL_TRAINING_FULFILLED:
      return {
        ...state,
        isLoading: false,
        trainingList: action.payload.trainingList,
        courseList: action.payload.courseList,
        skillList: action.payload.skillList,
        collaboratorsList: action.payload.collaboratorsList,
        instructorList: action.payload.instructorList,
        userFieldsDefinition: action.payload.userFieldsDefinition,
      };
    case actionTypes.GET_ALL_TRAINING_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.GET_SPECIFIC_TRAINING:
      return { ...state, isLoading: true };
    case actionTypes.GET_SPECIFIC_TRAINING_FULFILLED:
      return {
        ...state,
        isLoading: false,
        training: action.payload.training,
      };
    case actionTypes.GET_SPECIFIC_TRAINING_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.GET_COURSE_TREE:
      return { ...state, isLoading: true };
    case actionTypes.GET_COURSE_TREE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        trainingTree: action.payload.trainingTree,
      };
    case actionTypes.GET_COURSE_TREE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.CREATE_TRAINING:
      return { ...state, isLoading: true };
    case actionTypes.CREATE_TRAINING_FULFILLED:
      return {
        ...state,
        isLoading: false,
        trainingList: action.payload.trainingList,
        courseList: action.payload.courseList,
        instructorList: action.payload.instructorList,
        userFieldsDefinition: action.payload.userFieldsDefinition,
      };
    case actionTypes.CREATE_TRAINING_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.UPDATE_TRAINING:
      return { ...state, isLoading: true };
    case actionTypes.UPDATE_TRAINING_FULFILLED:
      return {
        ...state,
        isLoading: false,
        trainingList: action.payload.trainingList,
        courseList: action.payload.courseList,
        instructorList: action.payload.instructorList,
        userFieldsDefinition: action.payload.userFieldsDefinition,
      };
    case actionTypes.UPDATE_TRAINING_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.DELETE_TRAINING:
      return { ...state, isLoading: true };
    case actionTypes.DELETE_TRAINING_FULFILLED:
      return {
        ...state,
        isLoading: false,
        trainingList: action.payload.trainingList,
        courseList: action.payload.courseList,
        instructorList: action.payload.instructorList,
        userFieldsDefinition: action.payload.userFieldsDefinition,
      };
    case actionTypes.DELETE_TRAINING_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.DUPLICATE_TRAINING:
      return { ...state, isLoading: true };
    case actionTypes.DUPLICATE_TRAINING_FULFILLED:
      return {
        ...state,
        isLoading: false,
        trainingList: action.payload.trainingList,
        courseList: action.payload.courseList,
        instructorList: action.payload.instructorList,
        userFieldsDefinition: action.payload.userFieldsDefinition,
      };
    case actionTypes.DUPLICATE_TRAINING_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.RESET_SPECIFIC_TRAINING:
      return {
        ...state,
        course: null,
      };

    // MODULES ///////////////////////////////////////////////////////////////////////////

    case actionTypes.GET_MODULES:
      return { ...state, isLoadingModules: true };
    case actionTypes.GET_MODULES_FULFILLED:
      return {
        ...state,
        isLoadingModules: false,
        modules: action.payload.modules,
      };
    case actionTypes.GET_MODULES_REJECTED:
      return { ...state, isLoadingModules: false };

    case actionTypes.CREATE_MODULE:
      return { ...state, isLoadingModules: true };
    case actionTypes.CREATE_MODULE_FULFILLED:
      return {
        ...state,
        isLoadingModules: false,
        modules: action.payload.modules,
      };
    case actionTypes.CREATE_MODULE_REJECTED:
      return { ...state, isLoadingModules: false };

    case actionTypes.UPDATE_MODULE:
      return { ...state, isLoadingModules: true };
    case actionTypes.UPDATE_MODULE_FULFILLED:
      return {
        ...state,
        isLoadingModules: false,
        modules: action.payload.modules,
      };
    case actionTypes.UPDATE_MODULE_REJECTED:
      return { ...state, isLoadingModules: false };

    case actionTypes.DELETE_MODULE:
      return { ...state, isLoadingModules: true };
    case actionTypes.DELETE_MODULE_FULFILLED:
      return {
        ...state,
        isLoadingModules: false,
        modules: action.payload.modules,
      };
    case actionTypes.DELETE_MODULE_REJECTED:
      return { ...state, isLoadingModules: false };

    // ACTIVITIES ///////////////////////////////////////////////////////////////////////////

    case actionTypes.GET_ACTIVITIES:
      return { ...state, isLoadingActivities: true };
    case actionTypes.GET_ACTIVITIES_FULFILLED:
      return {
        ...state,
        isLoadingActivities: false,
        activities: action.payload.activities,
        media: action.payload.media,
        activityTypes: action.payload.activityTypes,
        questionTypes: action.payload.questionTypes,
        sessionTypes: action.payload.sessionTypes,
      };
    case actionTypes.GET_ACTIVITIES_REJECTED:
      return { ...state, isLoadingActivities: false };

    case actionTypes.GET_ACTIVITY:
      return { ...state, isLoadingActivities: true };
    case actionTypes.GET_ACTIVITY_FULFILLED:
      return {
        ...state,
        isLoadingActivities: false,
        activity: action.payload.activity,
      };
    case actionTypes.GET_ACTIVITY_REJECTED:
      return { ...state, isLoadingActivities: false };

    case actionTypes.CREATE_ACTIVITY:
      return { ...state, isLoadingActivities: true };
    case actionTypes.CREATE_ACTIVITY_FULFILLED:
      return {
        ...state,
        isLoadingActivities: false,
        activities: action.payload.activities,
        media: action.payload.media,
      };
    case actionTypes.CREATE_ACTIVITY_REJECTED:
      return { ...state, isLoadingActivities: false };

    case actionTypes.UPDATE_ACTIVITY:
      return { ...state, isLoadingActivities: true };
    case actionTypes.UPDATE_ACTIVITY_FULFILLED:
      return {
        ...state,
        isLoadingActivities: false,
        activities: action.payload.activities,
        media: action.payload.media,
      };
    case actionTypes.UPDATE_ACTIVITY_REJECTED:
      return { ...state, isLoadingActivities: false };

    case actionTypes.DELETE_ACTIVITY:
      return { ...state, isLoadingActivities: true };
    case actionTypes.DELETE_ACTIVITY_FULFILLED:
      return {
        ...state,
        isLoadingActivities: false,
        activities: action.payload.activities,
        media: action.payload.media,
      };
    case actionTypes.DELETE_ACTIVITY_REJECTED:
      return { ...state, isLoadingActivities: false };

    case actionTypes.RESET_MODULES_AND_ACTIVITIES:
      return {
        ...state,
        modules: [],
        activities: [],
      };

    case actionTypes.RESET_ACTIVITY:
      return {
        ...state,
        activity: null,
      };

    // ASSIGNMENT ///////////////////////////////////////////////////////////////////////////
    case actionTypes.GET_TRAINING_ASSIGNMENT:
      return { ...state, isLoading: true };
    case actionTypes.GET_TRAINING_ASSIGNMENT_FULFILLED:
      return {
        ...state,
        isLoading: false,
        canAssign: action.payload.canAssign,
        assignedCollaborators: action.payload.assignedCollaborators,
        collaboratorsList: action.payload.collaboratorsList,
      };
    case actionTypes.GET_TRAINING_ASSIGNMENT_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.CREATE_TRAINING_ASSIGNMENT:
      return { ...state, isLoading: true };
    case actionTypes.CREATE_TRAINING_ASSIGNMENT_FULFILLED:
      return {
        ...state,
        isLoading: false,
        assignedCollaborators: action.payload.assignedCollaborators,
      };
    case actionTypes.CREATE_TRAINING_ASSIGNMENT_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.DELETE_TRAINING_ASSIGNMENT:
      return { ...state, isLoading: true };
    case actionTypes.DELETE_TRAINING_ASSIGNMENT_FULFILLED:
      return {
        ...state,
        isLoading: false,
        assignedCollaborators: action.payload.assignedCollaborators,
      };
    case actionTypes.DELETE_TRAINING_ASSIGNMENT_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.RESET_TRAINING_ASSIGNMENT:
      return {
        ...state,
        canAssign: false,
        assignedCollaborators: [],
        collaboratorsList: [],
      };

    default:
      return state;
  }
}
